<template>
  <el-container>

    <el-affix position="top">
      <el-header class="w b">
        <el-row :gutter="10" class="bg">
          <el-col :xs="18" :sm="24" :md="12" :lg="8" :xl="1" ><div class="grid">WETOUCH·助力中国特色数字社会</div></el-col>
        </el-row>
      </el-header>
    </el-affix>
  
     <BrandInfo/>
     <CasesList/>
     <CasesInfo/>
     <ContactInfo/> 
          
  <el-footer>
    <div id="footer" class="w">
      Copyright © 2022  &nbsp;&nbsp;<a class="w" href="https://beian.miit.gov.cn/">京ICP备2022020332号-1</a>
    </div>
  </el-footer>
  
  </el-container>
</template>

<script>
import CasesList from './components/CasesList.vue'
import CasesInfo from './components/CasesInfo.vue'
import BrandInfo from './components/BrandInfo.vue' 
import ContactInfo from './components/ContactInfo.vue'

export default {
  name: 'App',
  components: {
    CasesInfo,  
    CasesList,
    BrandInfo,
    ContactInfo,
},
  
  data() {
      return{
          //case_list:CasesInfo.data().case_list,
          //service_list:CasesInfo.data().service_list,
          }
      }
  }

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
